import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bordered-group',
  templateUrl: './bordered-group.component.html',
  styleUrls: ['./bordered-group.component.scss'],
})
export class BorderedGroupComponent {
  @Input()
  header: string;
}
